import { EXPORT_TYPE_NAMES, ExportType, ExportTypes } from 'constants/exportTypes';

import { SelectChangeEvent } from '@mui/material';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';

import { ButtonStyled, SelectStyled } from './ExportTypesButton.styled';

export type ExportTypesButtonProps = {
  disabled?: boolean;
  exportType: ExportType;
  onClick: () => void;
  onChangeType: (exportType: ExportType) => void;
};

export const ExportTypesButton: React.FC<ExportTypesButtonProps> = ({
  disabled,
  exportType,
  onClick,
  onChangeType,
}) => {
  const translate = useTypedTranslate();

  function onChange(event: SelectChangeEvent<unknown>) {
    onChangeType(event.target.value as ExportType);
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start' }}>
      <ButtonStyled
        color="primary"
        disabled={disabled}
        label={`${translate('app.buttons.exportTo')} ${EXPORT_TYPE_NAMES[exportType]}`}
        onClick={onClick}
        size="medium"
        variant="contained"
      />
      <SelectStyled
        MenuProps={{
          PaperProps: {
            sx: {
              transform:
                exportType === ExportTypes.Excel
                  ? 'translateX(-38px) !important'
                  : 'translateX(-30px) !important',
            },
          },
        }}
        disabled={disabled}
        onChange={onChange}
        value={exportType}
      >
        <MenuItem
          value={ExportTypes.Excel}
        >{`${translate('app.buttons.exportTo')} Excel`}</MenuItem>
        <MenuItem value={ExportTypes.CSV}>{`${translate('app.buttons.exportTo')} CSV`}</MenuItem>
      </SelectStyled>
    </div>
  );
};
